import { use, useEffect, useRef, useState } from 'react';
// import EditComponent from './GiftCardEdit';
import WebUniversal, { initDataType, WUExtendPropsType } from '../../system/WebUniversalNewEx';
// import GiftCardPlansDetails from './GiftCardPlansDetails';
import { columnsheadId } from '../../universal/columnshead';
import { Button, Col, DatePicker, Form, Popover, Row, Select, Space, Tooltip } from 'antd';
import dayjs from 'dayjs';
import fetchApi from '../../../utils/api/fetchApi';
import AntdNotification from '../../../utils/extend/AntdNotification';
import system from '../../../config/systematic';
import getList from '../../universal/getList';

const GiftCard = (props: any) => {
    const ref = useRef<any>(undefined);
    const wmService: any = system.wmService;



    /** 当前打开的 Popover ID2 */
    const [activePopoverId2, setActivePopoverId2] = useState<string | null>(null);
    /** 后端数据defaultService */
    const [InitData, setInitData] = useState<any>();
    const [form] = Form.useForm();
    const [giftCardStatus, setGiftCardStatus] = useState<any>();
    const giftCardStatusId = Form.useWatch("giftCardStatusId", form) as any;
    const usageDate = Form.useWatch("usageDate", form) as any;
    const paymentDate = Form.useWatch("paymentDate", form) as any;
    const refundDate = Form.useWatch("refundDate", form) as any;

    const usageShopIds = Form.useWatch("usageShopIds", form) as any;
    const sellShopIds = Form.useWatch("sellShopIds", form) as any;
    const [usageShop, setUsageShop] = useState<Array<any>>([]);
    const [sellShop, setSellShop] = useState<Array<any>>([]);


    useEffect(() => {
        if (ref.current) {
            // urlService = ref.current.defaultService;
            // setDefaultService(urlService);
            setInitData(() => ref.current.initData);
        }
        fetchApi.GET(
            wmService,
            {
                apiId: "branchStore",
                apiExtend: 'showListManage'
            }
        ).then(res => {
            if (res.success) {
                setUsageShop(res.data);
                setSellShop(res.data);
            }
        })
    }, []);
    useEffect(() => {
        fetchApi.GET(wmService, {
            apiId: "generalData",
            apiExtend: 'bms',
            apiData: {
                apiId: 'generalData',
                apiExtend: 'showList',
                apiVariable: 'giftCardStatus',
            }
        }).then(res => {
            if (res.success) {
                setGiftCardStatus(res.data)
            }
        }).catch((err) => {
            console.log("err", err);
        })
    }, [])
    const apiId = "giftCard";
    //表头
    const columnsHead = [
        {
            title: '方案',
            dataIndex: 'giftCardPlans',
            render: (val: any, record: any) => {
                let showText;
                if (val&&val.planName) {
                    showText = val.planName;
                } else {
                    try {
                        const backupJson = JSON.parse(record.backupStringify);
                        
                        const { planName } = backupJson;
                        showText = planName;
                    } catch { }
                }
                return (<Tooltip placement="topLeft" title={showText}>{
                    (typeof showText !== "undefined" && showText !== null) ?
                        (showText.length >= 8 ? `${showText.substring(0, 8)}......` : showText)
                        : ''
                }</Tooltip>);
            }
        },
        {
            title: '礼品卡状态',
            dataIndex: 'giftCardStatus',
            render: (text: any) => {
                let color;
                switch (text?.id) {
                    case 0:
                        color = 'yellow';
                        break;
                    case -1:
                        color = 'red';
                        break;
                    case 2:
                        color = 'blue';
                        break;
                    default:
                        color = 'white';
                        break;
                }
                return (<><text style={{ color }}> {text?.name}</text></>)
            }
        },
        {
            title: '销售店',
            dataIndex: 'sellShopName',
        },
        {
            title: '核销店',
            dataIndex: 'usageShopName',
        },
        {
            title: '支付状态',
            dataIndex: 'paymentStatus',
            render: (text: any) => {
                let color;
                switch (text?.id) {
                    case 'Unpaid':
                        color = 'yellow';
                        break;
                    default:
                        color = 'white';
                        break;
                }
                return (<><text style={{ color }}> {text?.name}</text></>)
            }
        },
        {
            title: '支付日期',
            dataIndex: 'paymentDate',
            render: (text: any) => dayjs(text).format('YYYY-MM-DD HH:mm:ss')
        },
        {
            title: '使用日期',
            dataIndex: 'usageDate',
            render: (text: any) => dayjs(text).format('YYYY-MM-DD HH:mm:ss')
        },
        {
            title: '退款日期',
            dataIndex: 'refundDate',
            render: (text: any) => dayjs(text).format('YYYY-MM-DD HH:mm:ss')
        },
        {
            title: 'keyId',
            dataIndex: 'keyId',
            render: (text: any) => <Tooltip placement="topLeft" title={text}>{
                (typeof text !== "undefined" && text !== null) ?
                    (text.length >= 10 ? `${text.substring(0, 10)}......` : text)
                    : ''
            }</Tooltip>
        },
        {
            title: '平台',
            dataIndex: 'platform',
            render: (text: any) => text?.name
        },
        {
            title: '关联id',
            dataIndex: 'associationId',
            render: (text: any) => <Tooltip placement="topLeft" title={text}>{
                (typeof text !== "undefined" && text !== null) ?
                    (text.length >= 10 ? `${text.substring(0, 10)}......` : text)
                    : ''
            }</Tooltip>
        },
        {
            title: '',
            dataIndex: 'id',
            render: (id: string, record: any) => {
                if (record.paymentStatusId === 'Paid' && record.isUse === true) {
                    // if (record.giftCardStatusId === 1) {
                    //     return (
                    //         <Popover
                    //             title="是否退款？"
                    //             trigger="click"
                    //             content={(<Space>
                    //                 <Button onClick={() => setActivePopoverId(null)}>否</Button>
                    //                 <Button type='primary' onClick={() => {
                    //                     fetchApi.PUT(defaultService,
                    //                         {
                    //                             apiId: 'giftCard',
                    //                             apiExtend: 'buyVoid',
                    //                             apiData: {
                    //                                 giftCardId: id
                    //                             }
                    //                         }).then(res => {
                    //                             if (res?.success === true) {
                    //                                 AntdNotification('success', '执行退款成功');
                    //                                 InitData();
                    //                             } else {
                    //                                 AntdNotification('error', res?.message);
                    //                             }
                    //                         });
                    //                     setActivePopoverId(null);
                    //                 }}>是</Button>
                    //             </Space>)}
                    //             open={activePopoverId === id}
                    //             onOpenChange={(visible) => {
                    //                 setActivePopoverId(visible ? id : null);
                    //             }}
                    //         >
                    //             <Button type="default">退款</Button>
                    //         </Popover>
                    //     )
                    // }

                    if (record.giftCardStatusId === 2) {
                        const currentData: initDataType = {
                            apiId,
                            sendPageData: { usageDate: usageDate ? dayjs(usageDate).format("YYYY-MM-DD") : null, paymentDate: paymentDate ? dayjs(paymentDate).format("YYYY-MM-DD") : null, refundDate: refundDate ? dayjs(refundDate).format("YYYY-MM-DD") : null, sellShopIds, usageShopIds, giftCardStatusId }
                        }
                        return (
                            <Popover
                                title="是否冲正？"
                                trigger="click"
                                content={(<Space>
                                    <Button onClick={() => setActivePopoverId2(null)}>否</Button>
                                    <Button type='primary' onClick={() => {
                                        fetchApi.PUT(wmService,
                                            {
                                                apiId: 'giftCard',
                                                apiExtend: 'revokeRedeem',
                                                apiData: {
                                                    ids: [id]
                                                }
                                            }).then(res => {

                                                if (res?.success === true) {
                                                    AntdNotification('success', '执行冲正成功');
                                                    ref.current.initData(currentData)
                                                } else {
                                                    AntdNotification('error', res?.message);
                                                }
                                            }).catch((err) => {
                                                console.log("err", err);

                                            })
                                        setActivePopoverId2(null);
                                    }}>是</Button>
                                </Space>)}
                                open={activePopoverId2 === id}
                                onOpenChange={(visible) => {
                                    setActivePopoverId2(visible ? id : null);
                                }}
                            >
                                <Button type="default">冲正</Button>
                            </Popover>
                        )
                    }
                }
            }

            // (




            // (record.giftCardStatusId === 1 && record.paymentStatusId === 'Paid' && record.isUse === true) ?
            //     <Popover
            //         title="是否退款？"
            //         trigger="click"
            //         content={(<Space>
            //             <Button onClick={() => setActivePopoverId(null)}>否</Button>
            //             <Button type='primary' onClick={() => {
            //                 fetchApi.PUT(defaultService,
            //                     {
            //                         apiId: 'giftCard',
            //                         apiExtend: 'buyVoid',
            //                         apiData: {
            //                             giftCardId: id
            //                         }
            //                     }).then(res => {
            //                         if (res?.success === true) {
            //                             AntdNotification('success', '执行退款成功');
            //                             InitData();
            //                         } else {
            //                             AntdNotification('error', res?.message);
            //                         }
            //                     });
            //                 setActivePopoverId(null);
            //             }}>是</Button>
            //         </Space>)}
            //         open={activePopoverId === id}
            //         onOpenChange={(visible) => {
            //             setActivePopoverId(visible ? id : null);
            //         }}
            //     >
            //         <Button type="default">退款</Button>
            //     </Popover> : null)
        }
    ];

    const columns = columnsheadId
        .concat(columnsHead as []);

    let extendProps: WUExtendPropsType = {
        ...props,
        titleName: '礼品卡',
        apiId,
        columns,
        showStates: false,
        showOperation: false,
        showAdd: false,
        pagination: true,
        // EditComponent,
        serviceId: 'business',
        sendPageData: {
            sellShopIds, usageShopIds, giftCardStatusId, usageDate: usageDate ? dayjs(usageDate).format("YYYY-MM-DD") : null, paymentDate: paymentDate ? dayjs(paymentDate).format("YYYY-MM-DD") : null, refundDate: refundDate ? dayjs(refundDate).format("YYYY-MM-DD") : null
        }

    };
    const sellShopChange = (e: any) => {

        const currentData: initDataType = {
            apiId,
            sendPageData: { usageDate: usageDate ? dayjs(usageDate).format("YYYY-MM-DD") : null, paymentDate: paymentDate ? dayjs(paymentDate).format("YYYY-MM-DD") : null, refundDate: refundDate ? dayjs(refundDate).format("YYYY-MM-DD") : null, sellShopIds: e, usageShopIds, giftCardStatusId }
        }

        ref.current.initData(currentData);
    }

    const usageShopChange = (e: any) => {
        const currentData: initDataType = {
            apiId,
            sendPageData: { usageDate: usageDate ? dayjs(usageDate).format("YYYY-MM-DD") : null, paymentDate: paymentDate ? dayjs(paymentDate).format("YYYY-MM-DD") : null, refundDate: refundDate ? dayjs(refundDate).format("YYYY-MM-DD") : null, sellShopIds, usageShopIds: e, giftCardStatusId }
        }
        ref.current.initData(currentData);
    }
    //根据日期回显数据
    const handleDate = (e: any) => {
        let orderDateEx;
        if (e) {
            orderDateEx = dayjs(e).format("YYYY-MM-DD")


        } else {
            form.setFieldValue("usageDate", null)
        }

        const currentData: initDataType = {
            apiId,
            sendPageData: { usageDate: orderDateEx, sellShopIds, paymentDate: paymentDate ? dayjs(paymentDate).format("YYYY-MM-DD") : null, refundDate: refundDate ? dayjs(refundDate).format("YYYY-MM-DD") : null, usageShopIds, giftCardStatusId }
        }

        ref.current.initData(currentData);
    }
    //根据日期回显数据
    const handlePaymentDate = (e: any) => {
        let orderDateEx;
        if (e) {
            orderDateEx = dayjs(e).format("YYYY-MM-DD")


        } else {
            form.setFieldValue("paymentDate", null)
        }

        const currentData: initDataType = {
            apiId,
            sendPageData: { paymentDate: orderDateEx, sellShopIds, usageDate: usageDate ? dayjs(usageDate).format("YYYY-MM-DD") : null, refundDate: refundDate ? dayjs(refundDate).format("YYYY-MM-DD") : null, usageShopIds, giftCardStatusId }
        }

        ref.current.initData(currentData);
    }
    //根据日期回显数据
    const handleRefundDate = (e: any) => {
        let orderDateEx;
        if (e) {
            orderDateEx = dayjs(e).format("YYYY-MM-DD")


        } else {
            form.setFieldValue("refundDate", null)
        }

        const currentData: initDataType = {
            apiId,
            sendPageData: { refundDate: orderDateEx, sellShopIds, paymentDate: paymentDate ? dayjs(paymentDate).format("YYYY-MM-DD") : null, usageDate: usageDate ? dayjs(usageDate).format("YYYY-MM-DD") : null, usageShopIds, giftCardStatusId }
        }

        ref.current.initData(currentData);
    }

    const giftCardStatusChange = (e: any, option: any) => {


        const currentData: initDataType = {
            apiId,
            sendPageData: { sellShopIds, usageShopIds, giftCardStatusId: e, paymentDate: paymentDate ? dayjs(paymentDate).format("YYYY-MM-DD") : null, refundDate: refundDate ? dayjs(refundDate).format("YYYY-MM-DD") : null, usageDate: usageDate ? dayjs(usageDate).format("YYYY-MM-DD") : null }
        }
        ref.current.initData(currentData);

    }
    return (
        <>
            <Form form={form} initialValues={{ dataStatusType: 1 }}>
                <Row>
                    <Col span={8}>

                        <Form.Item
                            name="usageDate"
                            label="使用日期"
                        >
                            <DatePicker
                                allowClear
                                // defaultValue={moment(data.bookingDate)}
                                format="YYYY-MM-DD"
                                onChange={handleDate}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={8}>

                        <Form.Item
                            name="paymentDate"
                            label="支付日期"
                        >
                            <DatePicker
                                allowClear
                                // defaultValue={moment(data.bookingDate)}
                                format="YYYY-MM-DD"
                                onChange={handlePaymentDate}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={8}>

                        <Form.Item
                            name="refundDate"
                            label="退款日期"
                        >
                            <DatePicker
                                allowClear
                                // defaultValue={moment(data.bookingDate)}
                                format="YYYY-MM-DD"
                                onChange={handleRefundDate}
                            />
                        </Form.Item>
                    </Col>


                    <Col span={12}>

                        <Form.Item
                            name="giftCardStatusId"
                            label="礼品卡状态"
                        >
                            <Select
                                allowClear
                                // style={{ width: "300px" }}
                                onChange={giftCardStatusChange}
                                // orderTypeData
                                mode="multiple"
                                showSearch
                                placeholder="请选择状态!"
                                optionFilterProp="children"

                                filterOption={(input:any, option: any) => {
                                    return true
                                }}
                            >
                                {getList.general(giftCardStatus, 'name')}
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col span={12}>

                        <Form.Item
                            name="sellShopIds"
                            label="销售门店"
                        >
                            <Select
                                allowClear
                                // style={{ width: "300px" }}
                                onChange={sellShopChange}
                                // orderTypeData
                                mode="multiple"
                                showSearch
                                placeholder="请选择状态!"
                                optionFilterProp="children"

                                filterOption={(input:any, option: any) => {
                                    return true
                                }}
                            >
                                {getList.general(sellShop, 'branchStoreName')}
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col span={12}>

                        <Form.Item
                            name="usageShopIds"
                            label="核销门店"
                        >
                            <Select
                                allowClear
                                // style={{ width: "300px" }}
                                onChange={usageShopChange}
                                // orderTypeData
                                mode="multiple"
                                showSearch
                                placeholder="请选择状态!"
                                optionFilterProp="children"

                                filterOption={(input:any, option: any) => {
                                    return true
                                }}
                            >
                                {getList.general(usageShop, 'branchStoreName')}
                            </Select>
                        </Form.Item>
                    </Col>



                </Row>
            </Form>

            <WebUniversal props={extendProps} ref={ref} />
            {/* {modalGiftCardPlansDetails
                ? (<GiftCardPlansDetails
                    key={detailsData.id}
                    onClose={() => setModalGiftCardPlansDetails(false)}
                    data={detailsData} />)
                : null} */}
        </>
    )
}

export default GiftCard;
